/* eslint-disable react/destructuring-assignment */
import React, { SVGProps } from 'react';

function UrgentFlagIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask id="mask0_887_1049" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="17">
        <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_887_1049)">
        <path d="M4.66661 9.49998V13.8333C4.66661 13.975 4.61867 14.0937 4.52279 14.1896C4.42693 14.2854 4.30813 14.3333 4.16639 14.3333C4.02467 14.3333 3.90595 14.2854 3.81023 14.1896C3.71449 14.0937 3.66663 13.975 3.66663 13.8333V4.10258C3.66663 3.93186 3.72438 3.78875 3.83988 3.67327C3.95536 3.55777 4.09847 3.50002 4.26919 3.50002H8.56531C8.70756 3.50002 8.83458 3.54468 8.94636 3.634C9.05814 3.72331 9.12855 3.83933 9.15761 3.98207L9.33069 4.83335H12.3974C12.5681 4.83335 12.7112 4.89085 12.8267 5.00587C12.9422 5.12087 12.9999 5.26337 12.9999 5.43337V10.2334C12.9999 10.4034 12.9422 10.5459 12.8267 10.6609C12.7112 10.7758 12.5681 10.8333 12.3974 10.8333H9.43458C9.29232 10.8333 9.1653 10.7887 9.05353 10.6993C8.94175 10.61 8.87133 10.494 8.84228 10.3513L8.66919 9.49998H4.66661Z" fill="#AE0C0C" />
      </g>
    </svg>
  );
}

export default UrgentFlagIcon;
